import CloseIcon from '@mui/icons-material/Close';
import { Alert, Box, IconButton } from '@mui/material';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { useLocation } from 'react-router-dom';
import { selectCompany } from '../../core/config-loader/store/config-loader-slice';
import { useCompanyLogoConfig } from '../../core/hooks/useCompanyLogoConfig';
import { LoginErrors } from '../http/dto/loginErrors';

const LoginHeader: React.FC<{
  isLoading: boolean;
  errors?: LoginErrors;
}> = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const unauthorized = queryParams.get('unauthorized');

  const [showError, setShowError] = React.useState(true);

  const { t } = useTranslation();
  const company = useSelector(selectCompany);
  const { getCompanyLoginLogoConfig, getCompanyLoginLogoSrc } = useCompanyLogoConfig(company, false);

  const handleCloseError = () => {
    setShowError(false);
  };

  return (
    <>
      <div style={{ position: 'relative' }}>
        {showError && (
          <Box
            sx={{
              position: 'absolute',
              top: '-30px',
              width: '300px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {!!props.errors?.otherError && (
              <Alert
                severity="error"
                action={
                  <IconButton aria-label="close" color="inherit" size="small" onClick={handleCloseError}>
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {t(props.errors.otherError)}
              </Alert>
            )}
            {!!Boolean(unauthorized) && (
              <Alert
                severity="error"
                action={
                  <IconButton aria-label="close" color="inherit" size="small" onClick={handleCloseError}>
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
              >
                {t('LOGIN.UNAUTHORIZED')}
              </Alert>
            )}
          </Box>
        )}
        <Box sx={{ marginBottom: '24px' }}>
          <img style={getCompanyLoginLogoConfig()} src={getCompanyLoginLogoSrc()} alt="SFA Admin logo" />
        </Box>
      </div>
      <Typography component="h1" variant="h5">
        {t('LOGIN.TITLE')}
      </Typography>
    </>
  );
};

export default LoginHeader;
